<template>
    <div>
        <div id="uploadfile2">
            <div class="form-group form-inline" style="display: flex">
                <div class="pic2" id="picker2">选择文件</div>
                &nbsp;
                <div id="ctlBtn2" class="uped_but">开始上传</div>
            </div>
            <div id="thelist2" class="uploader-list"></div>

        </div>
    </div>
</template>


<script>
    export default {
        name: 'upload2',
        data() {
            return {
                a: 1
            };
        },
        mounted() {
            let that = this;
            this.$nextTick(() => {
                that.upload();
            })

        },
        methods: {
            clears() {
                $(".uploader-list").empty()

            },
            upload() {
                let that = this;
                var $list = $("#thelist2"),
                    $btn = $("#ctlBtn2");



                var uploader = WebUploader.create({
                    resize: false, // 不压缩image
                    swf: "/public/static/js/Uploader.swf", // swf文件路径
                    server: "/admin/pc/fpUpload", // 文件接收服务端。
                    pick: "#picker2", // 选择文件的按钮。可选
                    chunked: true, //是否要分片处理大文件上传
                    chunkSize: 1 * 1024 * 1024, //分片上传，每片2M，默认是5M
                    formData: {
                        image_class_id: '72',
                        file_type: '2',
                    },
                    headers: {
                        token: this.$store.state.user.token
                    },

                    fileVal: 'img',
                    fileNumLimit: 1


                });
                // 当有文件被添加进队列的时候
                uploader.on("fileQueued", function (file) {

                    $list.append(
                        '<div id="' +
                        file.id +
                        '" class="item"><div class="i_b_out"> <div class="i_b">' +
                        '<h4 class="info">' +
                        file.name +
                        "</h4> " +
                        '<p class="state">等待上传...</p> </div>' +
                        '<div class="ylbtn_b"></div>' +
                        `<div class="delsing"><i class='icon iconfont icon-cha1'></i></div>` +
                        "</div> </div>"
                    );
                });
                // 文件上传过程中创建进度条实时显示。
                uploader.on("uploadProgress", function (file, percentage) {
                    var $li = $("#" + file.id),
                        $percent = $li.find(".progress .progress-bar");
                    // 避免重复创建
                    if (!$percent.length) {
                        $percent = $(
                                '<div class="progress progress-striped active">' +
                                '<div class="progress-bar" role="progressbar" style="width: 0%">' +
                                "</div>" +
                                "</div>"
                            )
                            .appendTo($li)
                            .find(".progress-bar");
                    }
                    $li.find("p.state").text("上传中");
                    $percent.css("width", percentage * 100 + "%");
                });
                // 文件上传失败，显示上传出错
                uploader.on("uploadError", function (file) {
                    $("#" + file.id)
                        .find("p.state")
                        .text("上传出错");
                });
                // 完成上传完
                uploader.on("uploadComplete", function (file) {
                    $("#" + file.id)
                        .find(".progress")
                        .fadeOut();
                });
                $btn.on("click", function () {
                    if ($(this).hasClass("disabled")) {
                        return false;
                    }
                    uploader.upload();
                });
                $(".uploader-list").on('click', '.delsing', function () {
                    let fileid = $(this).parent().parent().attr('id')
                    let file = uploader.getFile(fileid, true)
                    uploader.removeFile(file, true);
                    $(`#${fileid}`).remove()
                    that.$emit("Delfile", file.name);

                })
                uploader.on("uploadSuccess", function (file, response) {

                    if (response.code == "200") {

                        that.$emit("uploaded", response);
                        let $yl = $("#" + file.id).children().children('.ylbtn_b')
                        let $percent = $yl.find(".ylbtn");
                        // 避免重复创建
                        if (!$percent.length) {
                            $percent = $(
                                    `<a href=${response.data.url} target='_blank' class="ylbtn">预览</a>`
                                )
                                .appendTo($yl)
                                .find(".ylbtn");
                        }
                        $("#" + file.id)
                            .find("p.state")
                            .text("已上传");
                    } else {
                        $("#" + file.id)
                            .find("p.state")
                            .text("上传失败");

                        alert("上传失败");
                    }
                });

            },
        },
    };
</script>

<style>
    @import '../../assets/css/demo.css';
    @import '../../assets/css/webuploader.css';
    @import '../../assets/css/style.css';

    .pic2 {
        /* width: 80px; */
        height: 38px;
    }

    a {
        color: #333;
    }

    a:hover {
        text-decoration: none;
    }

    .uped_but {
        width: 80px;
        height: 38px;
        border: 1px solid rgb(64, 158, 255);
        text-align: center;
        background: #409eff;
        color: #ffffff;
        border-radius: 4px;
    }

    .demo {
        min-width: 360px;
        margin: 30px auto;
        padding: 10px 20px;
    }

    .demo h3 {
        line-height: 40px;
        font-weight: bold;
    }

    .file-item {
        float: left;
        position: relative;
        width: 110px;
        height: 110px;
        margin: 0 20px 20px 0;
        padding: 4px;
    }

    .item {}

    .file-item .info {
        overflow: hidden;
    }

    .i_b_out {
        display: flex;
        align-items: center;
    }

    .ylbtn {
        margin-left: 80px;
        border: 1px solid #333;
        border-radius: 20px;
        padding: 0px 12px;
        font-size: 12px;
        transition: all .3s;
    }

    .ylbtn:hover {
        border: 1px solid #0078ff;
        color: #0078ff;
        cursor: pointer;
        box-shadow: 0 0 5px 0 rgba(0, 120, 255, .2);
        transition: all .3s;

    }

    .delsing {
        margin-left: 50px;
        cursor: pointer;
    }

    .uploader-list {
        width: 100%;
        overflow: hidden;
    }

    .webuploader-pick {
        padding: 0 15px;
    }

    .classborder {
        border: 1px solid #c1cdcd;
        width: 60%;
        text-align: center;
        border-radius: 2px;
    }

    .alert-danger {
        color: #a94442;
        background-color: #f2dede;
        border-color: #ebccd1;
    }

    .alert-danger hr {
        border-top-color: #e4b9c0;
    }

    .alert-danger .alert-link {
        color: #843534;
    }

    @-webkit-keyframes progress-bar-stripes {
        from {
            background-position: 40px 0;
        }

        to {
            background-position: 0 0;
        }
    }

    @-o-keyframes progress-bar-stripes {
        from {
            background-position: 40px 0;
        }

        to {
            background-position: 0 0;
        }
    }

    @keyframes progress-bar-stripes {
        from {
            background-position: 40px 0;
        }

        to {
            background-position: 0 0;
        }
    }

    .progress {
        height: 20px;
        margin-bottom: 20px;
        overflow: hidden;
        background-color: #f5f5f5;
        border-radius: 4px;
        -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
        box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
    }

    .progress-bar {
        float: left;
        width: 0;
        height: 100%;
        font-size: 12px;
        line-height: 20px;
        color: #fff;
        text-align: center;
        background-color: #337ab7;
        -webkit-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);
        box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);
        -webkit-transition: width 0.6s ease;
        -o-transition: width 0.6s ease;
        transition: width 0.6s ease;
    }

    .progress-bar-striped,
    .progress-striped .progress-bar {
        background-image: -webkit-linear-gradient(45deg,
                rgba(255, 255, 255, 0.15) 25%,
                transparent 25%,
                transparent 50%,
                rgba(255, 255, 255, 0.15) 50%,
                rgba(255, 255, 255, 0.15) 75%,
                transparent 75%,
                transparent);
        background-image: -o-linear-gradient(45deg,
                rgba(255, 255, 255, 0.15) 25%,
                transparent 25%,
                transparent 50%,
                rgba(255, 255, 255, 0.15) 50%,
                rgba(255, 255, 255, 0.15) 75%,
                transparent 75%,
                transparent);
        background-image: linear-gradient(45deg,
                rgba(255, 255, 255, 0.15) 25%,
                transparent 25%,
                transparent 50%,
                rgba(255, 255, 255, 0.15) 50%,
                rgba(255, 255, 255, 0.15) 75%,
                transparent 75%,
                transparent);
        -webkit-background-size: 40px 40px;
        background-size: 40px 40px;
    }

    .progress-bar.active,
    .progress.active .progress-bar {
        -webkit-animation: progress-bar-stripes 2s linear infinite;
        -o-animation: progress-bar-stripes 2s linear infinite;
        animation: progress-bar-stripes 2s linear infinite;
    }

    .progress-bar-success {
        background-color: #5cb85c;
    }

    .progress-striped .progress-bar-success {
        background-image: -webkit-linear-gradient(45deg,
                rgba(255, 255, 255, 0.15) 25%,
                transparent 25%,
                transparent 50%,
                rgba(255, 255, 255, 0.15) 50%,
                rgba(255, 255, 255, 0.15) 75%,
                transparent 75%,
                transparent);
        background-image: -o-linear-gradient(45deg,
                rgba(255, 255, 255, 0.15) 25%,
                transparent 25%,
                transparent 50%,
                rgba(255, 255, 255, 0.15) 50%,
                rgba(255, 255, 255, 0.15) 75%,
                transparent 75%,
                transparent);
        background-image: linear-gradient(45deg,
                rgba(255, 255, 255, 0.15) 25%,
                transparent 25%,
                transparent 50%,
                rgba(255, 255, 255, 0.15) 50%,
                rgba(255, 255, 255, 0.15) 75%,
                transparent 75%,
                transparent);
    }

    .progress-bar-info {
        background-color: #5bc0de;
    }

    .progress-striped .progress-bar-info {
        background-image: -webkit-linear-gradient(45deg,
                rgba(255, 255, 255, 0.15) 25%,
                transparent 25%,
                transparent 50%,
                rgba(255, 255, 255, 0.15) 50%,
                rgba(255, 255, 255, 0.15) 75%,
                transparent 75%,
                transparent);
        background-image: -o-linear-gradient(45deg,
                rgba(255, 255, 255, 0.15) 25%,
                transparent 25%,
                transparent 50%,
                rgba(255, 255, 255, 0.15) 50%,
                rgba(255, 255, 255, 0.15) 75%,
                transparent 75%,
                transparent);
        background-image: linear-gradient(45deg,
                rgba(255, 255, 255, 0.15) 25%,
                transparent 25%,
                transparent 50%,
                rgba(255, 255, 255, 0.15) 50%,
                rgba(255, 255, 255, 0.15) 75%,
                transparent 75%,
                transparent);
    }

    .progress-bar-warning {
        background-color: #f0ad4e;
    }

    .progress-striped .progress-bar-warning {
        background-image: -webkit-linear-gradient(45deg,
                rgba(255, 255, 255, 0.15) 25%,
                transparent 25%,
                transparent 50%,
                rgba(255, 255, 255, 0.15) 50%,
                rgba(255, 255, 255, 0.15) 75%,
                transparent 75%,
                transparent);
        background-image: -o-linear-gradient(45deg,
                rgba(255, 255, 255, 0.15) 25%,
                transparent 25%,
                transparent 50%,
                rgba(255, 255, 255, 0.15) 50%,
                rgba(255, 255, 255, 0.15) 75%,
                transparent 75%,
                transparent);
        background-image: linear-gradient(45deg,
                rgba(255, 255, 255, 0.15) 25%,
                transparent 25%,
                transparent 50%,
                rgba(255, 255, 255, 0.15) 50%,
                rgba(255, 255, 255, 0.15) 75%,
                transparent 75%,
                transparent);
    }

    .progress-bar-danger {
        background-color: #d9534f;
    }

    .progress-striped .progress-bar-danger {
        background-image: -webkit-linear-gradient(45deg,
                rgba(255, 255, 255, 0.15) 25%,
                transparent 25%,
                transparent 50%,
                rgba(255, 255, 255, 0.15) 50%,
                rgba(255, 255, 255, 0.15) 75%,
                transparent 75%,
                transparent);
        background-image: -o-linear-gradient(45deg,
                rgba(255, 255, 255, 0.15) 25%,
                transparent 25%,
                transparent 50%,
                rgba(255, 255, 255, 0.15) 50%,
                rgba(255, 255, 255, 0.15) 75%,
                transparent 75%,
                transparent);
        background-image: linear-gradient(45deg,
                rgba(255, 255, 255, 0.15) 25%,
                transparent 25%,
                transparent 50%,
                rgba(255, 255, 255, 0.15) 50%,
                rgba(255, 255, 255, 0.15) 75%,
                transparent 75%,
                transparent);

    }
</style>